import { ReactNode, useEffect } from "react";

// Shared bottom-sheet used by every BKFC drawer state, matching the app-wide
// drawer pattern (fixed overlay + white rounded-top sheet). Pass onClose to
// let a tap on the dark scrim dismiss the drawer; omit it for blocking states.
export function BkfcDrawer({
  children,
  onClose,
}: {
  children: ReactNode;
  onClose?: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "unset";
    };
  }, []);

  return (
    <div
      className="flex fixed inset-0 z-50 items-end h-dvh bg-black/70"
      onClick={onClose}
    >
      <div
        className="w-full bg-white rounded-t-[32px] px-6 pt-6 pb-10"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}
